export var RETURN_SUMMARY_LEGACY = {
    RETURN_LABEL_SUB: 'Check your email for a UPS barcode. An associate at ',
    RETURN_LABEL_SUB2: 'will scan and print a label for you.',
    RETURN_LABEL_SUB3: "If you don't receive an email within the next two hours, check your spam folder.",
    RETURN_LABEL_SUB4: "Going to a ",
    RETURN_LABEL_SUB5: " You'll need to print your label and attach it to the box.",
};
export var RETURN_SUMMARY = {
    PACKAGE: "Repack your return items",
    PACKAGE_SUB: "Pack your return items in a box.",
    PACKAGE_SUB2: "If you don't have a suitable box, select UPS locations will have one available for purchase.",
    RETURN_LABEL: 'Get your return barcode or label',
    RETURN_LABEL_SUB: 'Show the barcode to an associate at ',
    RETURN_LABEL_SUB2: 'and they will scan and print a label for you.',
    RETURN_LABEL_SUB3: "You can also check your email for a UPS barcode. If you don't receive an email within the next two hours, check your spam folder.",
    RETURN_LABEL_SUB4: "Going to a drop-off location?",
    RETURN_LABEL_SUB5: " You'll need to ",
    RETURN_LABEL_SUB6: " and attach it to the box.",
    RETURN: 'Return your items',
    RETURN_SUB: 'Drop off the items at a UPS location',
    MULTI_ADDRESS_RETURN_ALT: ' You can find printable labels in your return email or on the',
};
export var SORIS_RETURN_SUMMARY = {
    STEP_1_TITLE: 'Bring your return items in store',
    STEP_1_SUB: 'Take your return item(s) to any ',
    STEP_1_SUB2: ' to our returns or customer service counter.',
    STEP_2_TITLE: 'Scan your return QR code',
    STEP_2_SUB: 'Present your return QR code to the associate at the returns counter.',
    STEP_3_TITLE: 'Get your refund',
    QR_ALERT: 'Your QR code is available in your Purchase History and will be emailed to you.',
};
export var LORP_RETURN_SUMMARY = {
    STEP_1_TITLE: 'Schedule your pickup time',
    STEP_1_SUB: 'You will receive an email from Hub Group with a scheduling link to choose a pickup date and time.',
    STEP_2_TITLE: 'Prepare your item',
    STEP_2_SUB: 'Ensure the product is in a condition and location that allows the carrier to complete the pickup. A person 18 years or older must be present at the time of pickup.',
    STEP_3_TITLE: 'Rescheduling your pickup',
    STEP_3_SUB: 'If you need to change your pickup time after scheduling, please call 703-964-9500 for assistance.',
};
export var REFUND_TIMING_MESSAGE = 'Once we’ve received and processed your return, it may take up to 10 business days for your bank to put the funds back into your account.';
export var returnReasonCodes = {
    'It is defective': '1',
    'It was damaged during shipping': '9',
    "I didn't order this item or item type": '13',
    "It doesn't match the photos/description": '13',
    'I no longer want or need it': '14',
    'I found a more competitive price': '14',
    'I ordered the wrong type, size, etc': '15',
    'It arrived later than expected': '21',
};
export var FlowReturnMethodStep = {
    returnMethodFinished: false,
    itemsToReturnFinished: false,
    numberOfBoxesFinished: false,
    refundMethodFinished: false,
    lorpContactDetailsFinished: false,
    lorpWhatToExpectFinished: false,
    lorpUserAcknowledgeFinished: false,
};
export var FlowItemsToReturnStep = {
    returnMethodFinished: true,
    itemsToReturnFinished: false,
    numberOfBoxesFinished: false,
    refundMethodFinished: false,
    lorpContactDetailsFinished: false,
    lorpWhatToExpectFinished: false,
    lorpUserAcknowledgeFinished: false,
};
export var FlowDropOffBoxesStep = {
    returnMethodFinished: true,
    itemsToReturnFinished: true,
    numberOfBoxesFinished: false,
    refundMethodFinished: false,
    lorpContactDetailsFinished: false,
    lorpWhatToExpectFinished: false,
    lorpUserAcknowledgeFinished: false,
};
export var FlowRefundMethodStep = {
    returnMethodFinished: true,
    itemsToReturnFinished: true,
    numberOfBoxesFinished: true,
    refundMethodFinished: false,
    lorpContactDetailsFinished: false,
    lorpWhatToExpectFinished: false,
    lorpUserAcknowledgeFinished: false,
};
export var FlowLORPContactDetailsStep = {
    returnMethodFinished: true,
    itemsToReturnFinished: true,
    numberOfBoxesFinished: true,
    refundMethodFinished: true,
    lorpContactDetailsFinished: false,
    lorpWhatToExpectFinished: false,
    lorpUserAcknowledgeFinished: false,
};
export var FlowLORPWhatToExpectStep = {
    returnMethodFinished: true,
    itemsToReturnFinished: true,
    numberOfBoxesFinished: true,
    refundMethodFinished: true,
    lorpContactDetailsFinished: true,
    lorpWhatToExpectFinished: false,
    lorpUserAcknowledgeFinished: false,
};
export var FlowLORPUserAcknowledgeStep = {
    returnMethodFinished: true,
    itemsToReturnFinished: true,
    numberOfBoxesFinished: true,
    refundMethodFinished: true,
    lorpContactDetailsFinished: true,
    lorpWhatToExpectFinished: true,
    lorpUserAcknowledgeFinished: false,
};
export var FlowFinalizeReturnStep = {
    returnMethodFinished: true,
    itemsToReturnFinished: true,
    numberOfBoxesFinished: true,
    refundMethodFinished: true,
    lorpContactDetailsFinished: true,
    lorpWhatToExpectFinished: true,
    lorpUserAcknowledgeFinished: true,
};
